import { notify } from 'reapop'
import { MilestoneLogsConstants } from '../constants'
import { MilestoneLogService } from '../services'

export const MilestoneLogsActions = {
    getMilestoneLogs
}

function getMilestoneLogs(data) {
    return dispatch => {
        dispatch(request())

        MilestoneLogService.getMilestoneLogs(data)
            .then(
                verified => dispatch(success(verified)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(notify({ position: "tc", dismissible: false, message: error.toString(), status: "error" }))
                }
            )
    }

    function request() { return { type: MilestoneLogsConstants.GET_MilestoneLogs_REQUEST } }
    function success(result) { return { type: MilestoneLogsConstants.GET_MilestoneLogs_SUCCESS, result } }
    function failure(error) { return { type: MilestoneLogsConstants.GET_MilestoneLogs_FAILURE, error } }
}

